var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-yahoo",on:{"click":_vm.onClick}},[_c('img',{staticClass:"icon",attrs:{"src":require("../../../../../assets/images/sns/yahoo_japan_icon_w_64.png")}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }